export default "__VITE_ASSET__DGWObGVY__"